// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfg_a bhe_wh bhe_sq bhe_xj"};